import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-backend-not-available',
  templateUrl: './backend-not-available.component.html',
  styleUrls: ['./backend-not-available.component.scss']
})
export class BackendNotAvailableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
